module.exports = __webpack_public_path__ + "media/landing_page/builtin_sharing-68135f86.svg";